import { Pipe, PipeTransform } from '@angular/core';
import { RemittancePaymentStatus } from '../../../models/remittances/remittance-payment-status';
import { StatusPill } from '../../../models/shared/status-pill';
import { RemittancePaymentStatusPill } from '../../../models/shared/remittance-payment-status-pill';

@Pipe({
  name: 'remittancePaymentStatusPill',
  standalone: true
})
export class RemittancePaymentStatusPillPipe implements PipeTransform {
  transform(paymentStatus: RemittancePaymentStatus): StatusPill {
    return new RemittancePaymentStatusPill(paymentStatus.id, paymentStatus.name);
  }
}
